module.exports = __webpack_public_path__ + "img/empty-image.d5843e4c.svg";